import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=6f07a7ac&scoped=true"
import script from "./Results.vue?vue&type=script&lang=ts"
export * from "./Results.vue?vue&type=script&lang=ts"
import style0 from "./Results.vue?vue&type=style&index=0&id=6f07a7ac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07a7ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f07a7ac')) {
      api.createRecord('6f07a7ac', component.options)
    } else {
      api.reload('6f07a7ac', component.options)
    }
    module.hot.accept("./Results.vue?vue&type=template&id=6f07a7ac&scoped=true", function () {
      api.rerender('6f07a7ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Results.vue"
export default component.exports